export default "__VITE_ASSET__eafb0426__"